import { useQuery } from "@tanstack/react-query";
import { ListCategorysQueryFilters, UseListCategorysQueryOptions } from "./types";
import { getCategorysService } from "./service";

export const listCategorysQueryKey = ["category_admin"];

export function useListCategorysQuery(
  filters?: ListCategorysQueryFilters,
  options?: UseListCategorysQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listCategorysQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getCategorysService(filters),
    ...options,
  });
}
